import { useTranslation } from 'react-i18next';

import ConfirmDeletionModal from '../../components/Modal/ConfirmDeletionModal';
import { useCancelRequestBusinessPartner } from './companies.mutations';
import { CompanyTreeItem } from '../../components/Company/CompanyTree';

interface Props {
  company: CompanyTreeItem;
  isCompany: boolean;
  open: boolean;
  onClose: (shouldUpdate: boolean) => void;
}

function CancelCompanyModal({ company, isCompany, open, onClose }: Props) {
  const { t } = useTranslation('companies');
  const { mutateAsync: cancelRequestBusinessPartner } = useCancelRequestBusinessPartner();

  const handleDelete = async () => {
    // TODO: Add error handling
    await cancelRequestBusinessPartner(company.id ?? '');
    onClose(true);
  };

  return (
    <ConfirmDeletionModal
      title={t('cancelCompanyModal.cancelTitle')}
      description={
        isCompany
          ? t('cancelCompanyModal.cancelDescription')
          : t('cancelCompanyModal.cancelDescriptionDivision')
      }
      text={company.name}
      subText={
        company?.companyAddress &&
        [
          company.companyAddress.addressLineOne,
          company.companyAddress.addressLineTwo,
          `${company.companyAddress.city}, ${company.companyAddress.stateProvinceRegion}`,
          // TODO: Show full country name instead of two letter code?
          company.companyAddress.country,
        ].filter((line): line is string => line !== undefined)
      }
      primaryButtonText={t('cancelCompanyModal.cancelRequest')}
      secondaryButtonText={t('cancelCompanyModal.close')}
      iconName="business"
      open={open}
      onSubmit={handleDelete}
      onClose={onClose}
    />
  );
}

export default CancelCompanyModal;
